import Cargando from 'components/Varios/Cargando'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { ObtenerInformacionSolicitudes } from './FunctionsAprobacionSolicitudes'
import TableSolicitudesAprobar from './TableSolicitudesAprobar'
import { SolicitudesPorAprobar, TipoFiltroSolicitudAprobar } from './TypesAprobacionSolicitudes'
import { Container, Table, Row, Col, Label, Input, Button } from 'reactstrap'
import TableSolicitudesPermisosAprobar from './TableSolicitudesPermisosAprobar'
import TableSolicitudesCambioHorarioAprobar from './TableSolicitudesCambioHorarioAprobar'
import { GetDocumentVistaPrevia } from 'helpers/files'
import { UserData } from 'components/Sidebar/Sidebar_Principal'
import { authenticationService } from 'services/authentication.service'
import ModalVistaPreviaDocumentos from 'components/Varios/Modals/ModalVistaPreviaDocumentos'

type StateAprobacionSolicitudes = {
    filasTabla: SolicitudesPorAprobar[],
    loadingFilas: boolean,
    errorFilas: boolean,
    mensajeAprobacion: string | undefined,
    tipoSolicitud:TipoFiltroSolicitudAprobar
}

type StateModalVistaPrevia = {
    loading: boolean,
    url: string
}

export default function AprobacionSolicitudes() {

    const TITULO_APROBACION_SOLICITUDES = "APROBACIÓN DE SOLICITUD DE VACACIONES, PERMISO IMPUTABLE A VACACIONES, REINTEGRO DE VACACIONES, ANULACIÓN DE VACACIONES Y REPROGRAMACIÓN ";


    const defaulState: StateAprobacionSolicitudes = {
        filasTabla: [],
        loadingFilas: false,
        errorFilas: false,
        mensajeAprobacion: undefined,
        tipoSolicitud:TipoFiltroSolicitudAprobar.TODOS
    }

    const defaultStateModalVistaPrevia: StateModalVistaPrevia = {
        loading: false,
        url: ""
    }

    const [stateAprobacion, setstateAprobacion] = useState<StateAprobacionSolicitudes>(defaulState)
    const [tipoFiltro, setTipoFiltro] = useState(TipoFiltroSolicitudAprobar.TODOS);
    const [stateModalVP, setstateModalVP] = useState<StateModalVistaPrevia>(defaultStateModalVistaPrevia)

    const handleTipoSolicitudChange = (event) => {
        setTipoFiltro(event.target.value);
    };

    async function ObtenerDatosVacaciones(tipo:TipoFiltroSolicitudAprobar) {
        setstateAprobacion({ ...stateAprobacion, loadingFilas: true,tipoSolicitud:tipo })
        const resultado = await ObtenerInformacionSolicitudes(tipo)
        if (resultado.status === 200) {


            if (typeof (resultado.dataResponse) === "string") {
                setstateAprobacion({ ...stateAprobacion, mensajeAprobacion: resultado.dataResponse, loadingFilas: false, tipoSolicitud: tipo })

            }
            else{
                setstateAprobacion({ ...stateAprobacion, filasTabla: resultado.dataResponse, loadingFilas: false, tipoSolicitud: tipo })
         
            }
        }
        else {
            setstateAprobacion({ ...stateAprobacion, loadingFilas: false, errorFilas: true,tipoSolicitud:tipo })
        }

    }

    useEffect(() => {
        ObtenerDatosVacaciones(tipoFiltro);
        
    }, [tipoFiltro])

    const onClickVerDoc = useCallback(
        async (referencia: string) => {
            setstateModalVP({ ...stateModalVP, loading: true })
            const datosUsuario: UserData = authenticationService.currentUserValue;
            const url = await GetDocumentVistaPrevia(referencia, datosUsuario.token);
            setstateModalVP({ ...stateModalVP, loading: false, url })
        }, [stateModalVP]
    )


    const tablaSolicitudes = useMemo(() => {
        const { loadingFilas, errorFilas, filasTabla, tipoSolicitud } = stateAprobacion
        if (tipoSolicitud == "SOLVAC" || tipoSolicitud == "TO") {
            if (loadingFilas) {
                return <Cargando mensaje='Cargando Solicitudes' />;
            }
            else if (!loadingFilas && errorFilas) {
                return <div>No ha sido posible cargar la información</div>
            }
            else if (filasTabla.length > 0) {
                return (
                    <TableSolicitudesAprobar
                        dataprops={stateAprobacion.filasTabla}
                        recargarInformacionTabla={() => ObtenerDatosVacaciones(tipoSolicitud)}
                        filtrarTiposSolicitud={(tipo: TipoFiltroSolicitudAprobar) => ObtenerDatosVacaciones(tipo)}
                        tipoFiltroSolicitud={stateAprobacion.tipoSolicitud}
                    />
                )

            }
            else {
                return (
                    <TableSolicitudesAprobar
                        dataprops={[]}
                        recargarInformacionTabla={() => ObtenerDatosVacaciones(tipoSolicitud)}
                        filtrarTiposSolicitud={(tipo: TipoFiltroSolicitudAprobar) => ObtenerDatosVacaciones(tipo)}
                        tipoFiltroSolicitud={stateAprobacion.tipoSolicitud}
                    />
                )
            }
        } else if (tipoSolicitud == "PER") {
            
            if (loadingFilas) {
                return <Cargando mensaje='Cargando Solicitudes' />;
            }
            
            else if (!loadingFilas && errorFilas) {
                return <div>No ha sido posible cargar la información</div>
            }
            else if (filasTabla.length > 0) {
                return (
                    <TableSolicitudesPermisosAprobar
                        dataprops={stateAprobacion.filasTabla}
                        recargarInformacionTabla={() => ObtenerDatosVacaciones(tipoSolicitud)}
                        filtrarTiposSolicitud={(tipo: TipoFiltroSolicitudAprobar) => ObtenerDatosVacaciones(tipo)}
                        tipoFiltroSolicitud={stateAprobacion.tipoSolicitud} 
                        onClickVerDocumento={async (referencia: string) => await onClickVerDoc(referencia)}           
                    />
                )

            }
            else {
                return (
                    <TableSolicitudesPermisosAprobar
                        dataprops={[]}
                        recargarInformacionTabla={() => ObtenerDatosVacaciones(tipoSolicitud)}
                        filtrarTiposSolicitud={(tipo: TipoFiltroSolicitudAprobar) => ObtenerDatosVacaciones(tipo)}
                        tipoFiltroSolicitud={stateAprobacion.tipoSolicitud}
                        onClickVerDocumento={async (referencia: string) => {;}}
                    />
                )
            }
        } else if (tipoSolicitud == "SOLCAM") {
            if (loadingFilas) {
                return <Cargando mensaje='Cargando Solicitudes' />;
            }
            else if (!loadingFilas && errorFilas) {
                return <div>No ha sido posible cargar la información</div>
            }
            else if (filasTabla.length > 0) {
                return (
                    <TableSolicitudesCambioHorarioAprobar
                        dataprops={stateAprobacion.filasTabla}
                        recargarInformacionTabla={() => ObtenerDatosVacaciones(tipoSolicitud)}
                        filtrarTiposSolicitud={(tipo: TipoFiltroSolicitudAprobar) => ObtenerDatosVacaciones(tipo)}
                        tipoFiltroSolicitud={stateAprobacion.tipoSolicitud}
                    />
                    
                )

            }
            else {
                return (
                    <TableSolicitudesCambioHorarioAprobar
                        dataprops={stateAprobacion.filasTabla}
                        recargarInformacionTabla={() => ObtenerDatosVacaciones(tipoSolicitud)}
                        filtrarTiposSolicitud={(tipo: TipoFiltroSolicitudAprobar) => ObtenerDatosVacaciones(tipo)}
                        tipoFiltroSolicitud={stateAprobacion.tipoSolicitud}
                    />
                )
            }
        }
        
    }, [stateAprobacion])

    const ButtonFiltrarPermisosSolicitudesVacaciones = useMemo(() => {

        return (
            <>
                <Label>Seleccionar solicitudes de: </Label>
                <Input value={tipoFiltro} type="select" onChange={handleTipoSolicitudChange}>
                    {/*<option value={TipoFiltroSolicitudAprobar.VACACIONES}>Vacaciones y Permisos Imputables</option>*/}
                    <option value={TipoFiltroSolicitudAprobar.PERMISOS}>Permisos y Licencias</option>
                </Input>
            </>

        )

    }, [tipoFiltro])


    return (
        <div className="content">
            <Row>
                <Col xl={4}>
                    {ButtonFiltrarPermisosSolicitudesVacaciones}
                </Col>
            </Row>
            <Row className="mt-5">
                <Col xl={12}>
                    <div className={"titulo_seccion"}>{"SOLICITUDES DE PERMISOS Y LICENCIAS"}</div>
                </Col>
            </Row>
            {/* <div className="titulo_seccion mb-5"> {TITULO_APROBACION_SOLICITUDES} </div>
            {
                <p className='small-error'>{stateAprobacion.mensajeAprobacion} </p>
            }
            <Row className={"mb-3 rowBotonFiltroAprobacionMasivaSolicitudes"}>

                <Col xl={2}>
                    {ButtonFiltrarPermisosSolicitudesVacaciones}
                </Col>
                
            </Row> */}
            {
                tablaSolicitudes
            }

            <ModalVistaPreviaDocumentos
                cargandoDatos={stateModalVP.loading}
                onClose={() => setstateModalVP(defaultStateModalVistaPrevia)}
                show={stateModalVP.loading || stateModalVP.url !== ""}
                size="xl"
                tituloModal='Documento de permisos y/o licencias'
                urlArchivo={stateModalVP.url}
                botonCerrar={true}
            />

        </div>
    )
}
